<template>
    <div class="col-12">
        <div v-if="item.itemImage != false && item.itemStyle == 'featured'" class="menu-wrapper">
            <div class="menu-item">
                <div class="menu__item-img"><img v-bind:src=" item.itemImage " alt="menu img"></div>
                <div class="menu__item-content">
                    <h4 class="menu__item-title">{{ item.itemName }}</h4>
                    <span class="menu__item-price">{{ item.itemPrice }}€</span>
                    <p class="menu__item-desc">{{ item.itemDescription }}</p>   
                </div>
            </div>
        </div>
        <div v-else class="menu-item">
            <h4 class="menu__item-title">{{ item.itemName }}</h4>
            <span class="menu__item-price">{{ item.itemPrice }}€</span>
            <p class="menu__item-desc">{{ item.itemDescription }}</p>
        </div><!-- /.menu-item -->

    </div><!-- /.col-lg-6 -->
</template>

<script>
export default {
    name: 'SectionContent',
    props: ['item'],

}

</script>


<style>
 .menu-item {
     text-align: left;
}
</style>